<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table
                            :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @delete-items="deleteItems"
                            @import-items="importItems"
                            @change-selected="changeSelectedTable"
                            @row-click="rowClick"
                            ref="gofixTable">
                            <template slot="gofix_table:after-control-left" slot-scope="data">    
                                <gofix-button v-if="filterFileType == 'DORJ'" :disabled="!$checkRole($accessModule.allow_accept_incoming, 'allow_accept_incoming') || actionAcceptStatus == false" label="Accept" class="ml-4 mr-3" @click="actionAccept"></gofix-button>
                                <gofix-button :disabled="!$checkRole($accessModule.allow_reject_incoming, 'allow_reject_incoming') || actionRejectStatus == false" label="Reject" class="mr-3 gofixButtonOutLine" @click="actionReject"></gofix-button>
                                <gofix-button :label="!isShowAll ? 'Show All' : '&times; Show All'" class="mr-3 gofixButtonOutLine" @click="showAllStatus"></gofix-button>
                            </template>
                            <template slot="gofix_table:before-control-right" slot-scope="data">
                                <div class="mr-2 d-flex align-items-center filterCompany filterMaint">
                                    <gofix-form-dropdown
                                            :class="[ 'highlightDropdown chartOfAccountDropdown min-width-0', 'width-99' ]"
                                            label=""
                                            vLabel="description_one"
                                            :clearable="false"
                                            :filterable="false"
                                            :options="filterFileTypes"
                                            v-model="filterFileType"
                                            :placeholder="'File Type'">
                                        <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                            <span class="text-hidden-one-row">{{ option.description_one || '-' }}</span>
                                        </template>
                                        <template slot="gofixInput:dropdown:option" slot-scope="option">
                                            <div class="maintOption">
                                                <span>{{ option.description_one || '-' }}</span>
                                            </div>
                                        </template>
                                    </gofix-form-dropdown>
                                </div>
                            </template>
                            <template slot="gofix_table:actions" slot-scope="row" v-if="!['Draft','Validated'].includes(row.item.status) || ['INVOICE'].includes(row.item.file_type)">
                                <!-- <b-form-checkbox disabled></b-form-checkbox> -->
                            </template>
                            <template slot="gofix_table:batch_no" slot-scope="row">
                                <span class="checklistLink" @click="goToDetail(row.item.id)"> {{ row.item.batch_no }} </span>
                            </template>
                            <template slot="gofix_table:batch_date" slot-scope="row">
                                {{ row.item.batch_date ? row.item.batch_date : '' | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
                            </template>
                            <template slot="gofix_table:document_date" slot-scope="row">
                                {{ row.item.document_date ? row.item.document_date : '' | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
                            </template>
                            <template slot="gofix_table:replacement_date" slot-scope="row">
                                {{ row.item.replacement_date ? row.item.replacement_date : '' | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
                            </template>
                            <template slot="gofix_table:unit_price" slot-scope="row">
                                {{ `${$accounting.formatMoney(row.item.unit_price)}` }}
                            </template>
                            <template slot="gofix_table:discount" slot-scope="row">
                                {{ `${$accounting.formatMoney(row.item.discount)}` }}
                            </template>
                            <template slot="gofix_table:total_price" slot-scope="row">
                                {{ `${$accounting.formatMoney(row.item.total_price)}` }}
                            </template>
                            <template slot="gofix_table:gst" slot-scope="row">
                                {{ `${$accounting.formatMoney(row.item.gst)}` }}
                            </template>
                            <template slot="gofix_table:attachments" slot-scope="row">
                                <div v-if="row.item.document && row.item.document.attachments.length > 0" class="attachmentsColumn" @click.stop="doThisImages(row.item.document.attachments)">
                                    <div class="items">
                                        <viewer-image :images="row.item.document.attachments" :showImage="true">
                                            <template slot="gofixViewer:list_image" slot-scope="{images}">
                                                <div class="item" v-for="attachment in images">
                                                    <div class="item-content position-relative" @click="downloadFile(attachment)">
                                                        <span class="icon" v-html="$options.filters.iconFile(attachment, icons, true)"></span>
                                                        <span class="name">{{attachment.image_file_title || attachment.image_file_name}}</span>
                                                        <!-- <img class="image-viewer" v-if="checkShowImage(attachment.image_content_type)" v-auth-image="attachment.url.original" :key="attachment.url.original"  src="img/loading.gif"> -->
                                                    </div>
                                                </div>
                                            </template>
                                        </viewer-image>
                                    </div>
                                </div>
                            </template>
                            <template slot="gofix_table:submitted_on" slot-scope="row">
                                {{ row.item.submitted_on ? row.item.submitted_on : '' | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") }}
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js'
    const ViewerImage = () => import('../../plugins/ViewerImage.vue')
    export default {
        name: 'incoming-documents',
        components: { 
            ViewerImage
        },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['incoming_documents']));
            return {
                tableConfig:{
                    name: 'lmu-incoming-documents',
                    controls:{
                        create: false,
                        update: true,
                        delete: false,
                        tableImport: false,
                        tableExport: false,
                        reload: true,
                        tablePagination: true,
                        tableFilter: true
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    sortColumn: "batch_date",
                    sortDirection: "desc",
                    itemSelected: [],
                    fields: []
                },
                tableItems: [],
                filterFileTypes: ['DORJ', 'INVOICE'],
                filterFileType: 'DORJ',
                actionAcceptStatus: false,
                actionRejectStatus: false,
                btnAction: {
                    ids: []
                },
                images:[],
                icons: {
                    'application': {
                        'word': {
                            'img': 'word.png',
                            'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094ZM9.28301 8.29688H8.71699C8.62031 8.29688 8.53594 8.36191 8.51309 8.45684L7.63945 11.9531L6.8291 8.46035C6.80625 8.36543 6.72187 8.29688 6.62344 8.29688H6.00117C5.96884 8.29693 5.93695 8.3044 5.90795 8.31871C5.87896 8.33303 5.85364 8.3538 5.83395 8.37945C5.81425 8.40509 5.8007 8.43491 5.79434 8.46661C5.78798 8.49831 5.78898 8.53105 5.79727 8.5623L7.10156 13.4139C7.12617 13.5053 7.21055 13.5703 7.30547 13.5703H7.86797C7.96289 13.5703 8.04727 13.507 8.07188 13.4139L9 9.95098L9.92812 13.4139C9.95273 13.5053 10.0371 13.5703 10.132 13.5703H10.691C10.7859 13.5703 10.8703 13.507 10.8949 13.4139L12.2027 8.5623C12.2109 8.53105 12.2119 8.49834 12.2055 8.46667C12.1991 8.43499 12.1856 8.4052 12.1659 8.37958C12.1462 8.35396 12.1209 8.33318 12.0919 8.31885C12.063 8.30451 12.0311 8.29699 11.9988 8.29688H11.373C11.2746 8.29688 11.1902 8.36543 11.1674 8.46035L10.3623 11.9602L9.48691 8.45684C9.46406 8.36191 9.37969 8.29688 9.28301 8.29688Z" fill="#666666"/></svg>'
                        },
                        'excel': {
                            'img': 'excel.png',
                            'svg': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0297 6.76406L14.9859 1.72031C14.8453 1.57969 14.6555 1.5 14.4562 1.5H4.5C4.08516 1.5 3.75 1.83516 3.75 2.25V21.75C3.75 22.1648 4.08516 22.5 4.5 22.5H19.5C19.9148 22.5 20.25 22.1648 20.25 21.75V7.29609C20.25 7.09687 20.1703 6.90469 20.0297 6.76406ZM18.5203 7.64062H14.1094V3.22969L18.5203 7.64062ZM18.5625 20.8125H5.4375V3.1875H12.5156V8.25C12.5156 8.51107 12.6193 8.76145 12.8039 8.94606C12.9885 9.13066 13.2389 9.23438 13.5 9.23438H18.5625V20.8125ZM12.0492 13.5961L10.6008 11.1961C10.5492 11.1117 10.4578 11.0602 10.3594 11.0602H9.45938C9.40547 11.0602 9.35391 11.0742 9.30938 11.1047C9.17813 11.1867 9.13828 11.3602 9.22266 11.4937L11.1516 14.55L9.19687 17.6625C9.17032 17.7052 9.15565 17.7542 9.15438 17.8045C9.15312 17.8547 9.1653 17.9044 9.18968 17.9484C9.21405 17.9923 9.24973 18.029 9.29303 18.0546C9.33632 18.0801 9.38566 18.0937 9.43594 18.0938H10.2445C10.343 18.0938 10.432 18.0422 10.4836 17.9602L11.9531 15.5812L13.4133 17.9578C13.4648 18.0422 13.5562 18.0914 13.6523 18.0914H14.5312C14.5852 18.0914 14.6367 18.075 14.6836 18.0469C14.8148 17.9625 14.8523 17.7891 14.768 17.6578L12.7992 14.6016L14.7984 11.4961C14.8255 11.4535 14.8407 11.4045 14.8423 11.3541C14.844 11.3037 14.8322 11.2537 14.808 11.2095C14.7838 11.1652 14.7482 11.1282 14.7049 11.1024C14.6616 11.0765 14.6122 11.0628 14.5617 11.0625H13.725C13.6266 11.0625 13.5352 11.1141 13.4836 11.1984L12.0492 13.5961Z" fill="#666666"/></svg>'
                        },
                        'pdf': {
                            'img': 'pdf.png',
                            'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.33926 10.0969L9.34453 10.0723C9.44648 9.65215 9.5748 9.12832 9.47461 8.65371C9.40781 8.2793 9.13184 8.1334 8.89629 8.12285C8.61855 8.11055 8.3707 8.26875 8.30918 8.49902C8.19316 8.9209 8.29688 9.49746 8.48672 10.2322C8.24766 10.8018 7.86621 11.6297 7.58672 12.1219C7.06641 12.3908 6.36855 12.8057 6.26484 13.3295C6.24375 13.4262 6.26836 13.5492 6.32637 13.66C6.39141 13.783 6.49512 13.8779 6.61641 13.9236C6.66914 13.943 6.73242 13.9588 6.80625 13.9588C7.11563 13.9588 7.6166 13.7092 8.28457 12.5631C8.38652 12.5297 8.49199 12.4945 8.59395 12.4594C9.07207 12.2977 9.56777 12.1289 10.016 12.0533C10.5117 12.3188 11.076 12.4893 11.4592 12.4893C11.8389 12.4893 11.9883 12.2643 12.0445 12.1289C12.143 11.8916 12.0955 11.5928 11.9355 11.4328C11.7035 11.2043 11.1393 11.1445 10.2604 11.2535C9.82793 10.9898 9.54492 10.6313 9.33926 10.0969ZM7.41094 12.767C7.1666 13.1221 6.98203 13.2996 6.88184 13.377C6.99961 13.1607 7.22988 12.9322 7.41094 12.767ZM8.95078 8.62734C9.04219 8.78379 9.02988 9.25664 8.95957 9.4957C8.87344 9.1459 8.86113 8.6502 8.91211 8.59219C8.92617 8.59395 8.93848 8.60449 8.95078 8.62734ZM8.92266 10.7455C9.11074 11.0707 9.34805 11.3502 9.60996 11.5576C9.23027 11.6438 8.88398 11.7861 8.57461 11.9127C8.50078 11.9426 8.42871 11.9725 8.3584 12.0006C8.59219 11.577 8.7873 11.0971 8.92266 10.7455ZM11.6578 11.8969C11.6596 11.9004 11.6613 11.9057 11.6508 11.9127H11.6473L11.6438 11.918C11.6297 11.9268 11.4855 12.0111 10.865 11.7668C11.5787 11.7334 11.6561 11.8951 11.6578 11.8969ZM15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094Z" fill="#666666"/></svg>'
                        },
                    },
                    'image': {
                        'img': 'image.png',
                        'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.72246 8.94902L8.35488 10.6928L7.63242 9.77168C7.61927 9.75487 7.60246 9.74128 7.58327 9.73193C7.56409 9.72258 7.54302 9.71772 7.52168 9.71772C7.50034 9.71772 7.47927 9.72258 7.46009 9.73193C7.4409 9.74128 7.42409 9.75487 7.41094 9.77168L5.65664 12.0076C5.64041 12.0283 5.63034 12.0532 5.62758 12.0794C5.62482 12.1056 5.62948 12.132 5.64104 12.1557C5.65259 12.1793 5.67056 12.1992 5.69291 12.2132C5.71525 12.2271 5.74106 12.2344 5.76738 12.2344H12.2344C12.3521 12.2344 12.4172 12.099 12.3451 12.0076L9.9457 8.94902C9.93237 8.93219 9.91541 8.91859 9.89608 8.90924C9.87675 8.89989 9.85555 8.89503 9.83408 8.89503C9.81261 8.89503 9.79142 8.89989 9.77209 8.90924C9.75276 8.91859 9.73579 8.93219 9.72246 8.94902ZM6.32812 7.76953C6.32812 7.95601 6.4022 8.13485 6.53407 8.26672C6.66593 8.39858 6.84477 8.47266 7.03125 8.47266C7.21773 8.47266 7.39657 8.39858 7.52843 8.26672C7.6603 8.13485 7.73438 7.95601 7.73438 7.76953C7.73438 7.58305 7.6603 7.40421 7.52843 7.27235C7.39657 7.14049 7.21773 7.06641 7.03125 7.06641C6.84477 7.06641 6.66593 7.14049 6.53407 7.27235C6.4022 7.40421 6.32812 7.58305 6.32812 7.76953ZM15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094Z" fill="#666666"/></svg>'
                    },
                    'text': {
                        'img': 'notepad.png',
                        'svg': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0297 6.76406L14.9859 1.72031C14.8453 1.57969 14.6555 1.5 14.4562 1.5H4.5C4.08516 1.5 3.75 1.83516 3.75 2.25V21.75C3.75 22.1648 4.08516 22.5 4.5 22.5H19.5C19.9148 22.5 20.25 22.1648 20.25 21.75V7.29609C20.25 7.09687 20.1703 6.90469 20.0297 6.76406ZM18.5203 7.64062H14.1094V3.22969L18.5203 7.64062ZM18.5625 20.8125H5.4375V3.1875H12.5156V8.25C12.5156 8.51107 12.6193 8.76145 12.8039 8.94606C12.9885 9.13066 13.2389 9.23438 13.5 9.23438H18.5625V20.8125Z" fill="#666666"/><path d="M6.75 18H13.75V16.75H6.75V18ZM6.75 10.5V11.75H17.25V10.5H6.75ZM6.75 14.875H17.25V13.625H6.75V14.875Z" fill="#666666"/></svg>'
                    },
                    'inode': 'none'
                },
                isShowAll: false
            }
        },
        created() {
            
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
            }),
        },
        watch: {
            ClientContractID: function(val) {
                this.$refs.gofixTable.reloadTableItems();
            },
            "filterFileType": function(val) {
                this.$refs.gofixTable.reloadTableItems();
            },
        },
        filters: {
            iconFile(val, icons, is_svg = false) {
                let path = 'img/';
                let type_show = 'img';
                let extension = '';
                let type = val.type || val.image_content_type;

                if(is_svg) {
                    path = '';
                    type_show = 'svg';
                }
                if(val.type) extension = val.name.split('.')[1];

                let arrTemp = type.split('/');
                if(arrTemp && arrTemp.length == 2) {
                    let type = arrTemp[0];
                    if(!extension) extension = arrTemp[1];

                    if(type == 'application' || type == 'inode' || type == 'text') {
                        let key = 'pdf';
                        if(['docx', 'doc', 'vnd.openxmlformats-officedocument.wordprocessingml.document', 'msword'].includes(arrTemp[1])) key = 'word';
                        if(['xls', 'xlsx', 'vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'vnd.ms-excel'].includes(arrTemp[1])) key = 'excel';
                        if(['zip', 'x-empty', 'plain'].includes(arrTemp[1])) {
                            let extension = val.image_file_name.split('.')[1];
                            if(['doc', 'docx'].includes(extension)) key = 'word';
                            if(['xls', 'xlsx', 'csv'].includes(extension)) key = 'excel';
                        }
                        return `${path}${icons['application'][key][type_show]}`;
                    }

                    return `${path}${icons[type][type_show]}`;
                }
            }
        },
        methods: {
            async downloadFile(attachment) {
                let url = attachment.url.original;
                let params = {};
                params.url = url;
                params.image_file_name = attachment.image_file_name;
                await this.$store.dispatch("FileDownloadController/getFile", params)
                .then(response => {
                })
                .catch(err => {
                    this.$alertNotification("Can not download file", "danger");
                    console.log(err);
                })
            },
            doThisImages: function (attachments) {
                this.images = attachments
            },
            async getTableData(callback) {
                const { tableRequest , resolve, reject } = await callback();

                if(this.filterFileType){
                    tableRequest.filter.file_type.value = this.filterFileType
                    tableRequest.file_type = this.filterFileType
                }
                
                await this.$store.dispatch("BatchSubmissionController/getIncomingDocuments", tableRequest)
                .then(response => {
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    resolve(response);
                })
                .catch(err => { 
                    reject()
                })
            },
            async deleteItems(callback){
                
            },
            async importItems(callback){
                
            },
            downloadItem(url, label) {
                axios.get(url, { responseType: 'blob' })
                .then(response => {
                    const blob = new Blob([response.data], { type: 'application/pdf' })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = label
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch()
            },
            goToDetail(item) {
                if (item) {
                    this.$router.push(`/v2/incoming-documents/${item}`);
                }
            },
            changeSelectedTable(ids) {
                this.btnAction.ids = Array.from(new Set(ids))
                this.actionAcceptStatus = false
                this.actionRejectStatus = false
                if ( this.btnAction.ids.length !== 0 ) {
                    this.actionAcceptStatus = true
                    this.actionRejectStatus = true
                }
            },
            async actionAccept() {

                if ( !this.ClientContractID ) {
                    return this.$alertNotification("Please select contract.", "danger")
                }
                
                if ( !this.btnAction.ids ) {
                    return this.$alertNotification("Please select the item you want to update!", "danger")
                }

                let filter = this.tableItems.filter(item => this.btnAction.ids.includes(item.incoming_document_id) && item.status != 'Draft')
                if(filter.length) {
                    return this.$alertNotification("Please select items with Draft status", "danger")
                }

                /* Accepted & Rejected */
                let dataSave = {
                    header_id: this.btnAction.ids,
                    status: 'Accepted',
                    file_type: 'DORJ'
                }

                await this.$store.dispatch("BatchSubmissionController/updateStatus", dataSave)
                .then(response => {
                    this.$alertNotification("Successfully updated", "success");
                    this.$refs.gofixTable.reloadTableItems();
                })
                .catch(err => {
                    if (err.response.data.error && err.response.data.error.message) {
                        this.$alertNotification(err.response.data.error.message, "danger")
                    }
                })
            },
            async actionReject() {

                if ( !this.ClientContractID ) {
                    return this.$alertNotification("Please select contract.", "danger")
                }

                if ( !this.btnAction.ids ) {
                    return this.$alertNotification("Please select the item you want to update!", "danger")
                }

                /* Accepted & Rejected */
                let dataSave = {
                    header_id: this.btnAction.ids,
                    status: 'Rejected',
                    file_type: 'DORJ'
                }

                await this.$store.dispatch("BatchSubmissionController/updateStatus", dataSave)
                .then(response => {
                    this.$alertNotification("Successfully updated", "success");
                    this.$refs.gofixTable.reloadTableItems();
                })
                .catch(err => {
                    if (err.response.data.error && err.response.data.error.message) {
                        this.$alertNotification(err.response.data.error.message, "danger")
                    }
                })
            },
            showAllStatus() {
                this.isShowAll = !this.isShowAll
                this.$refs.gofixTable.tableRequest.filter.status.value = this.isShowAll ? '' : 'Draft';
                this.$refs.gofixTable.reloadTableKeepFilter();
            },
            rowClick(item) {
                this.goToDetail(item.id)
            },
        }
    }
</script>